export const ALLOWED_FILE_FORMATS = [
	'.doc',
	'.docx',
	'.gif',
	'.jpg ',
	'.jpeg',
	'.mpg',
	'.mpeg',
	'.avi',
	'.pdf',
	'.ppt',
	'.pptx',
	'.tif',
	'.tiff',
	'.txt',
	'.xls',
	'.xlsx'
]

export const MAX_FILE_SIZE = 10485760 // 10 MB
